<template>
  <div id="auth-container">
    <Card id="auth-card">
      <p slot="title">Авторизация</p>
      <Form
        ref="form"
        :model="model"
      >
        <FormItem>
          <Input
            type="email"
            v-model="model.email"
            placeholder="Email"
            v-on:keyup.enter.native="handleSignIn"
          />
        </FormItem>
        <FormItem>
          <Input
            type="password"
            v-model="model.password"
            placeholder="Пароль"
            v-on:keyup.enter.native="handleSignIn"
          />
        </FormItem>
        <Button
          type="primary" 
          long
          :loading="loading"
          v-on:click="handleSignIn"
        >
          Войти
        </Button>
      </Form>
    </Card>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';

import CryptoJS from 'crypto-js';

export default {
  data() {
    return {
      loading: false,
      model: {
        email: null,
        password: null
      }
    }
  },
  methods: {
    async handleSignIn() {
      this.loading = true;

      try {
        const admin = (await firebase.database().ref(`admin`).once('value')).val();

        await firebase.auth().signInWithEmailAndPassword(
          this.model.email, this.model.password
        );

        const cryptedEmail = CryptoJS.AES.encrypt(this.model.email, admin).toString();
        const cryptedPassword = CryptoJS.AES.encrypt(this.model.password, admin).toString();

        window.localStorage.setItem('cryptedEmail', cryptedEmail);
        window.localStorage.setItem('cryptedPassword', cryptedPassword);

        this.$Message.success("Добро пожаловать");

        this.$router.push('/');
      }
      catch(error) {
        console.log(error);

        this.$Message.error("Неверный логин или пароль");
      }

      this.loading = false;
    }
  }
}
</script>

<style scoped>
#auth-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
#auth-card {
  width: 300px;
}
</style>